<vbn-simple-banner
  title="Sales Materials"
  subTitle="Download all the tools you need to grow your sales!"
/>
<div class="content">
  <vbn-publications [publications]="publications()" (onClick)="handleClick($event)">
  </vbn-publications>
</div>
